import dayjs from 'dayjs';
import type { Dayjs } from 'dayjs';
import type { TOrderParseCargoAddressDtoRes, TOrderParseCargoDtoRes, TOrderParseCargoItemDtoRes } from 'api/swagger';
import { type CountryRes, type CreateCargoItemReq } from 'api/swagger';
import type { ICargoFormWithId } from 'components/cargos/cargo-create-with-order/types';
import type { IAddressFormFields } from 'components/cargos/cargo-form';

export const transformAiResultCargosToFromObject = (
  cargoes: TOrderParseCargoDtoRes[],
  countries?: CountryRes[],
): ICargoFormWithId[] => {
  const result = cargoes.map((cargo) => ({
    id: crypto.randomUUID(),
    isCompleted: false,
    loadingDate: prepareDateRange(cargo.loadingDateFrom, cargo.loadingDateTo),
    unloadingDate: prepareDateRange(cargo.unloadingDateFrom, cargo.unloadingDateTo),
    loadingAddress: prepareAddress(cargo.loadingAddress, countries),
    unloadingAddress: prepareAddress(cargo.unloadingAddress, countries),
    // loadingCustomAddress: cargo.loadingCustomAddress?.address
    //   ? prepareAddress(cargo.loadingCustomAddress, countries)
    //   : null,
    // unloadingCustomAddress: cargo.unloadingCustomAddress?.address
    //   ? prepareAddress(cargo.unloadingCustomAddress, countries)
    //   : null,
    loadingCustom: 'need_address',
    unloadingCustom: 'need_address',
    totalWeight: cargo.totalWeight,
    type: cargo.type,
    cargoItems: prepareCargoItem(cargo.cargoItems),
  })) as unknown as ICargoFormWithId[];

  return result;
};

const prepareDateRange = (dateFrom: string | null, dateTo: string | null): [Dayjs, Dayjs] | null => {
  if (!dateFrom || !dateTo) {
    return null;
  }

  return [dayjs(dateFrom), dayjs(dateTo)];
};

const prepareAddress = (
  address: TOrderParseCargoAddressDtoRes | null,
  countries?: CountryRes[],
): IAddressFormFields | null => {
  if (!address) {
    return null;
  }

  const country = countries?.find((country) => country.code === address.countryCode);

  return {
    name: address.name || '',
    countryId: country?.id || 0,
    postCode: address.postCode || '',
    city: address.city || '',
    address: address.address || '',
    description: address.description || '',
    referenceNumber: address.referenceNumber || '',
    extraData: address.extraData || [],
  };
};

const prepareCargoItem = (cargoItems: TOrderParseCargoItemDtoRes[] | null): CreateCargoItemReq[] => {
  if (!cargoItems) {
    return [];
  }

  return cargoItems.map((item) => ({
    count: item.count || 0,
    length: item.length || 0,
    width: item.width || 0,
    height: item.height || 0,
    stack: item.stack || 0,
  })) as CreateCargoItemReq[];
};
